function run(){
const first=document.getElementById('firstname').value.trim();
const last=document.getElementById('lastname').value.trim();
const email=(document.getElementById('email').value||'').trim();
const cells=[...document.querySelectorAll('#dobCells .dc')].map(c=>c.value.trim());
const err=document.getElementById('err');
const allDigits=cells.length===8&&cells.every(c=>/^[0-9]$/.test(c));
const emailOk=/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
if(!first||!last||!allDigits||!emailOk){err.textContent='Merci de renseigner vos prénoms, votre nom, une date de naissance complète (JJMMAAAA) et un email valide.';err.style.display='block';return}
const day=cells[0]+cells[1], month=cells[2]+cells[3], year=cells.slice(4).join('');
const dN=+day, mN=+month, yN=+year;
const dt=new Date(yN,mN-1,dN);
const validDate=mN>=1&&mN<=12&&dN>=1&&dN<=31&&yN>=1900&&yN<=2100&&dt.getDate()===dN&&dt.getMonth()===mN-1&&dt.getFullYear()===yN;
if(!validDate){err.textContent='Cette date de naissance ne semble pas valide. Vérifiez le jour, le mois et l’année.';err.style.display='block';return}
const dob=`${year}-${month}-${day}`;
err.style.display='none';
const R=compute(first,last,dob);
THEME=R;THEME.first=first;THEME.last=last;THEME.dobFR=day+'/'+month+'/'+year;THEME.dobISO=dob;THEME.email=email;
document.getElementById('heroCards').innerHTML=
numCard('Chemin de vie',R.cheminVie,(NAMES[R.cheminVie]||''),I_VIE[R.cheminVie])+
numCard('Expression',R.expression,'Votre signature',I_EXPR[R.expression])+
numCard('Nombre intime',R.ame,'Aspiration profonde',I_EXPR[R.ame]);
const p=PARFUMS[R.cheminVie]||PARFUMS[reduceM(R.cheminVie)];
document.getElementById('parfumReco').innerHTML=`<div class="parfum fade">
<div class="pnum serif" style="color:${colorVar(R.cheminVie)}">${valLabel(R.cheminVie)}</div>
<div>
<divclass="pk">Collection Numerus</div>
<div class="pname serif">${p.name}</div>
<div class="ptags">${p.tags}</div>
</div>
<a class="pcta" href="${p.url}" target="_blank" rel="noopener">Découvrir ce parfum</a>
</div>`;
const now=new Date();
const moisNom=now.toLocaleDateString('fr-FR',{month:'long'});
document.getElementById('nowCards').innerHTML=
numCard('Année personnelle '+R.ty,R.anneePerso,NAMES[R.anneePerso]||'',I_NOW[R.anneePerso])+
numCard('Mois de '+moisNom,R.moisPerso,NAMES[R.moisPerso]||'',I_NOW[R.moisPerso])+
numCard('Jourpersonnel',R.jourPerso,NAMES[R.jourPerso]||'',I_NOW[R.jourPerso]);
const pf=v=>PARFUMS[v]||PARFUMS[reduceM(v)];
const cyNames=['Cycle de formation','Cycle de productivité','Cycle de moisson'];
const cyAges=['première partie de vie','milieu de vie','dernière partie de vie'];
document.getElementById('cyclesTl').innerHTML=R.cycles.map((v,i)=>{
const p=pf(v);
return `<div class="tl-row fade"><div class="chip serif" style="color:${colorVar(v)}">${valLabel(v)}</div>
<div><div class="meta">${cyNames[i]} · ${cyAges[i]}</div>
<span class="nmn">${NAMES[v]||''}</span>
<div class="tx">${I_VIE[v]||I_ACTION[v]}</div>
<a class="tlcta" href="${p.url}" target="_blank" rel="noopener">Découvrir ${p.name}</a></div></div>`;}).join('');
document.getElementById('actionsTl').innerHTML=R.actions.map((v,i)=>{
const p=pf(v);
return `<div class="tl-row fade"><div class="chip serif" style="color:${colorVar(v)}">${valLabel(v)}</div>
<div><div class="meta">Réalisation ${i+1} · ${R.actionAges[i]}</div>
<span class="nmn">${NAMES[v]||''}</span>
<div class="tx">${I_ACTION[v]}</div>
<a class="tlcta" href="${p.url}" target="_blank" rel="noopener">Découvrir ${p.name}</a></div></div>`;}).join('');
document.getElementById('inclGrid').innerHTML=R.incl.map((v,i)=>
`<div class="cell ${v===0?'absent':''}"><span class="idx">${i+1}</span>
<span class="v serif" style="color:${v===0?'':colorVar(i+1)}">${v}</span></div>`).join('');
const absents=R.incl.map((v,i)=>v===0?i+1:null).filter(x=>x);
const top=R.incl.map((v,i)=>({n:i+1,v})).sort((a,b)=>b.v-a.v)[0];
let inclTxt=`<strong>Votre vibration la plus présente est le ${top.n}</strong> — ${NAMES[top.n]||''} (×${top.v}) : une qualité qui vous est naturelle. `;
inclTxt+=absents.length
? `Les nombres absents (${absents.join(', ')}) sont vos <strong>leçons karmiques</strong> : les énergies que cette vie vous invite à développer.`
: `Aucune vibration n'est absente de votre nom — un équilibre rare qui couvre tout le spectre.`;
document.getElementById('inclNote').innerHTML=inclTxt;
const total=R.planes.M+R.planes.P+R.planes.E+R.planes.I||1;
const order=['M','P','E','I'];
document.getElementById('planBars').innerHTML=order.map(k=>{
const pct=Math.round(R.planes[k]/total*100);
return `<div class="bar-row"><div class="lb">${PLANE_INFO[k].name}</div>
<div class="bar-track"><div class="bar-fill" style="width:0%" data-w="${pct}"></div></div>
<div class="vv serif">${R.planRed[k]}</div></div>`;
}).join('');
const dom=order.reduce((a,b)=>R.planes[b]>R.planes[a]?b:a);
document.getElementById('planText').innerHTML=`<strong style="color:var(--accent);font-weight:500">Plan dominant : ${PLANE_INFO[dom].name}.</strong> ${PLANE_TEXT[dom]}`;
setTimeout(()=>document.querySelectorAll('.bar-fill').forEach(b=>b.style.width=b.dataset.w+'%'),120);
document.getElementById('yearsGrid').innerHTML=R.cycle9.map(o=>{
const p=pf(o.val);
return `<a class="yr numlink-card ${o.year===R.ty?'now':''}" href="${p.url}" target="_blank" rel="noopener" title="Parfum ${p.name}">
<div class="y">${o.year}</div>
<div class="yn serif" style="color:${colorVar(o.val)}">${valLabel(o.val)}</div>
<div class="yt">${NAMES[o.val]||''}</div>
<div class="yp">${p.name}</div></a>`;}).join('');
const moisNoms=['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
document.getElementById('planAnneeLead').innerHTML=`Voici vos douze mois personnels pour <strong>${R.ty}</strong> (année personnelle <strong>${valLabel(R.anneePerso)}</strong>). Chaque mois porte sa propre énergie et son parfum compagnon — un guide pour traverser l'année en conscience.`;
document.getElementById('monthsBody').innerHTML=moisNoms.map((m,i)=>{
const v=R.moisAnnee[i],p=pf(v);
return `<tr><td>${m}</td><td class="mn" style="color:${colorVar(v)}">${valLabel(v)}</td>
<td style="color:var(--ink-soft);font-weight:400">${NAMES[v]||''}</td>
<td><a class="numlink" href="${p.url}" target="_blank" rel="noopener">${p.name}</a></td></tr>`;}).join('');
renderCalendar(R);
const res=document.getElementById('results');
res.style.display='block';
document.getElementById('leadMsg').textContent='';
res.scrollIntoView({behavior:'smooth',block:'start'});
}
